var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStartApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "50px",
    viewBox: "0 0 49 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/uni_app") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.59875 0.0365 39.375 0.0365 39.375 49.375 0.59875 49.375"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "p-01-One-Commercial-Homepage-AS-Style",
    transform: "translate(-715.000000, -534.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(645.000000, 524.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(67.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/start_application_one"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(3.125000, 2.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(9.375000, 0.588438)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.375,29.530875 L39.375,29.53025 L39.375,1.66525 C39.375,0.765875 38.645,0.0365 37.746875,0.0365 L2.22625,0.0365 C1.3275,0.0365 0.59875,0.765875 0.59875,1.66525 L0.59875,19.60275 C1.808125,19.644 2.976875,20.26275 3.671875,21.363375 C3.7225,21.443375 3.768125,21.524625 3.811875,21.607125 L3.855625,21.579625 L3.855625,3.293375 L36.1175,3.293375 L36.1175,30.394 C36.045625,31.840875 35.57625,32.917125 34.17125,33.478375 C32.274375,34.23775 30.339375,34.38775 26.4475,34.38775 C25.9675,34.38775 25.493125,34.49025 25.143125,34.819625 C24.794375,35.149 24.6075,35.615875 24.63375,36.09525 C24.805625,39.237125 24.800625,43.843375 23.325625,45.25025 C22.62125,45.923375 22.174375,46.114625 21.4375,46.114625 C20.538125,46.114625 3.855625,46.118375 3.855625,46.118375 L3.855625,38.68525 L0.59875,40.739625 L0.59875,47.747125 C0.59875,48.645875 1.3275,49.37525 2.22625,49.37525 C2.22625,49.37525 22.024375,49.3715 22.394375,49.3715 C23.529375,49.3715 24.6275,48.983375 25.663125,48.38775 C27.125,47.5465 36.163125,37.894625 37.22,36.679 C38.27375,35.46525 39.369375,33.734625 39.375,29.530875",
    id: "Fill-1",
    fill: "#45BCE5",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.400375,28.237 C0.636625,28.45825 0.946625,28.576375 1.261,28.576375 C1.491625,28.576375 1.724125,28.51325 1.932875,28.381375 L9.9735,23.303875 L10.532875,22.95075 C11.04725,22.62575 11.246625,21.990125 11.03975,21.442 C11.010375,21.36325 10.97225,21.287 10.925375,21.212625 C10.707875,20.86825 10.350375,20.666375 9.9735,20.632 C9.70725,20.607625 9.431,20.666375 9.18725,20.820125 L0.58725,26.25075 C-0.000875,26.622 -0.1765,27.400125 0.19475,27.9895 C0.2535,28.082625 0.322875,28.165125 0.400375,28.237",
    id: "Fill-4",
    fill: "#45BCE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.648375,22.7761875 L13.065875,23.1436875 L12.939625,23.2230625 L9.973375,25.0943125 L2.530875,29.7893125 L2.530875,29.7899375 C2.529,29.7905625 2.52775,29.7918125 2.525875,29.7924375 C2.108375,30.0561875 1.754625,30.3836875 1.47025,30.7536875 C0.458375,32.0693125 0.318375,33.9286875 1.255875,35.4136875 C2.45775,37.3168125 4.974625,37.8849375 6.877125,36.6830625 C6.973375,36.6224375 7.064,36.5586875 7.15275,36.4911875 L9.973375,34.7124375 L12.939625,32.8411875 L17.992125,29.6549375 L18.267125,29.4818125 L13.923375,22.6030625 L13.648375,22.7761875 Z",
    id: "Fill-6",
    fill: "#45BCE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.979625,14.0878125 C35.980875,13.9015625 35.930875,13.7128125 35.82275,13.5446875 C35.52775,13.0796875 34.913375,12.9421875 34.447125,13.2396875 L32.699,14.3528125 C32.0815,13.9371875 31.299625,13.7659375 30.489625,13.7590625 C28.8915,13.7490625 27.03275,14.3290625 25.395875,15.3659375 L16.054625,21.2584375 L15.78025,21.4315625 L20.123375,28.3103125 L20.398375,28.1371875 L29.769,22.2265625 C32.039,20.7434375 33.750875,18.5490625 33.812125,16.5140625 L33.81275,16.5034375 C33.813375,16.3453125 33.79775,16.1878125 33.772125,16.0303125 L35.517125,14.9203125 C35.814625,14.7315625 35.975875,14.4134375 35.979625,14.0878125",
    id: "Fill-8",
    fill: "#45BCE5"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStartApp);
export default __webpack_public_path__ + "static/media/icon-start-app.03e8575dfad35eef8df24c03b0b9b51a.svg";
export { ForwardRef as ReactComponent };